import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=d5e85e8c&scoped=true&"
import script from "./CardHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CardHorizontal.vue?vue&type=style&index=0&id=d5e85e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e85e8c",
  null
  
)

export default component.exports